<script setup>
import { storeToRefs } from "pinia";
import Slider from "primevue/slider";

import { useCriarQuestoesStore } from "@/store/criarQuestoes";
const store = useCriarQuestoesStore();
const { numeroQuestoes } = storeToRefs(store);

const quantidades = [2,4,6,8]

</script>

<template>
    <div class="flex flex-column gap-3">
        <label class="flex justify-content-between">
            <div>Quantidade</div>
            <div class="text-xs text-gray-500">{{ numeroQuestoes }} questões</div>
        </label>
        <Slider v-model="numeroQuestoes" :min="2" :max="10" class="w-full" />

    </div>

</template>
